import React from 'react';
import UserForm from '../forms/UserForm';
import Card from '../common/Card';

const CreateUserPage = ({ onBack }) => {
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-2 sm:px-3">
      <div className="flex items-center gap-3 sm:gap-4 mb-6 md:mb-8">
        <button
          onClick={handleBack}
          className="w-10 h-10 rounded-xl bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 text-slate-600 dark:text-slate-300 hover:text-slate-800 dark:hover:text-white transition-all duration-300 flex items-center justify-center btn-hover-scale shrink-0"
          aria-label="Back to users"
        >
          <i className="fas fa-arrow-left" aria-hidden="true"></i>
        </button>
        <div>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold gradient-text flex items-center gap-2 sm:gap-3">
            <span className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center shadow-lg shrink-0">
              <i className="fas fa-user-plus text-white text-lg sm:text-xl" aria-hidden="true"></i>
            </span>
            Create New User
          </h1>
          <p className="text-slate-600 dark:text-slate-400 ml-0 sm:ml-14 md:ml-16 text-sm sm:text-base mt-1">Add a new user with role-based permissions</p>
        </div>
      </div>

      <Card padding="lg">
        <UserForm onSuccess={handleBack} onCancel={handleBack} />
      </Card>
    </div>
  );
};

export default CreateUserPage;
